const DB_NAME = 'sep-offline-v1';

function database() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => request.result.createObjectStore('saved', { keyPath: 'key' });
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function clearOfflineData() {
  localStorage.removeItem('sep-offline-owner');
  const db = await database();
  await new Promise((resolve, reject) => {
    const transaction = db.transaction('saved', 'readwrite');
    transaction.objectStore('saved').clear();
    transaction.oncomplete = resolve; transaction.onerror = () => reject(transaction.error);
  });
  db.close();
}

export async function setOfflineOwner(user) {
  const id = String(user?.id || user?._id || '');
  if (user?.impersonating || !id) { await clearOfflineData(); return; }
  if (localStorage.getItem('sep-offline-owner') !== id) await clearOfflineData();
  localStorage.setItem('sep-offline-owner', id);
}

export async function storeOfflineItem(item) {
  const owner = localStorage.getItem('sep-offline-owner');
  if (!owner || !localStorage.getItem('token') || localStorage.getItem('impersonate_user_id')) throw new Error('Sign in as yourself before saving offline data.');
  if (item.owner && item.owner !== owner) throw new Error('The signed-in account changed.');
  const db = await database();
  await new Promise((resolve, reject) => {
    const transaction = db.transaction('saved', 'readwrite');
    transaction.objectStore('saved').put({ ...item, owner, saved_at: new Date().toISOString() });
    transaction.oncomplete = resolve; transaction.onerror = () => reject(transaction.error);
  });
  db.close();
}

export async function listOfflineItems(kind) {
  const owner = localStorage.getItem('sep-offline-owner');
  if (!owner || !localStorage.getItem('token') || localStorage.getItem('impersonate_user_id')) return [];
  const db = await database();
  try {
    const items = await new Promise((resolve, reject) => {
      const request = db.transaction('saved').objectStore('saved').getAll();
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
    if (localStorage.getItem('sep-offline-owner') !== owner) return [];
    return items.filter(item => item.owner === owner && (!kind || item.kind === kind));
  } finally { db.close(); }
}

export async function prepareOfflineAccess() {
  if ('serviceWorker' in navigator && window.isSecureContext && /^https?:$/.test(location.protocol)) {
    await navigator.serviceWorker.register('/push-sw.js', { scope: '/' });
    await navigator.serviceWorker.ready;
  }
}

export function eventOfflineSnapshot(event, userId) {
  const fields = ['name', 'start_date', 'end_date', 'location', 'description', 'emergency_contacts', 'event_timetable', 'event_schedule', 'fb_provisions', 'packing_list', 'uniform_info', 'visa_requirements'];
  const details = Object.fromEntries(fields.filter(key => event[key] !== undefined).map(key => [key, event[key]]));
  const schedule = (event.schedule_rows || []).filter(row => String(row.user_id) === String(userId)).map(row => ({ role: row.role, assigned_dates: row.assigned_dates, date_statuses: row.date_statuses }));
  return { key: `event:${event.id || event._id}`, kind: 'event', name: event.name, details, schedule, day_types: event.schedule_day_types || {} };
}

export async function readOfflineItem(key) {
  const owner = localStorage.getItem('sep-offline-owner');
  if (!owner || !localStorage.getItem('token') || localStorage.getItem('impersonate_user_id')) return null;
  const db = await database();
  try {
    const item = await new Promise((resolve, reject) => {
      const request = db.transaction('saved').objectStore('saved').get(key);
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
    return item?.owner === owner ? item : null;
  } finally { db.close(); }
}
export async function removeOfflineItem(key) {
  const db = await database();
  try {
    await new Promise((resolve, reject) => {
      const transaction = db.transaction('saved', 'readwrite');
      transaction.objectStore('saved').delete(key);
      transaction.oncomplete = resolve;
      transaction.onerror = () => reject(transaction.error);
    });
  } finally { db.close(); }
}
